import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getAccountMembers, type MemberResponse } from '../api';
import type { Account } from '../model';

import { useConditionalQuery } from './useAccountQuery';

export function useMembers(
  account: Account | null | undefined,
  options?: { url?: string; paginated?: boolean; enabled?: boolean },
) {
  return useConditionalQuery<MemberResponse | null, RequestError>(
    account
      ? [...queryKeys.accounts.members(account._id, { url: options?.url, paginated: options?.paginated })]
      : ['accounts', 'members', null, {}],
    ({ signal }) =>
      account
        ? observableToPromise(getAccountMembers(account, Boolean(options?.paginated), options?.url), signal)
        : Promise.resolve(null),
    Boolean(account) && (options?.enabled ?? true),
  );
}
